import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from '../../AxiosClient'

export const checkUser = createAsyncThunk(
  'login/check-user',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', `/ntapi/v1/common/check-user`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getDefaultRoutes = createAsyncThunk(
  'login/getDefaultRoutes',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('GET', `/ntapi/v1/common/get-user-with-default-route`, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const getAllRoutes = createAsyncThunk(
  'config/getAllRoutes',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    const referrer = sessionStorage.getItem('referrer')

    let url = `/ntapi/v1/app-config/get-config`

    if (referrer === 'corus') {
      url += `?referrer=${encodeURIComponent(referrer)}`
    }

    return await AxiosClient('GET', url, payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)
